export default __webpack_public_path__ + "static/media/thanks-dialog-image.fa29b45d.png";